import { ErrorHandler, Injectable } from "@angular/core"
import { ObservabilityService } from "./observability.service"

@Injectable()
export class ObservabilityErrorHandler implements ErrorHandler {
  constructor(private readonly observability: ObservabilityService) {}

  handleError(error: unknown): void {
    this.observability.trackUnhandledError(error)
    // Preserve Angular's local diagnostic behavior; no error message is sent to OTEL.
    console.error(error)
  }
}
